import { FormattedMessage } from 'react-intl';
import { Button, Nav, Tab } from 'react-bootstrap';
import { useEffect, useRef, useState } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';


export const Languages = () => {
  const [tab, setTab] = useState("templates");
  const { pathname } = useLocation();
  const [isActive, setIsActive] = useState(false);
  const refs = {
    "templates": useRef(null),
    "infos": useRef(null)
  } as {[x: string]: any};

  useEffect(() => {
    let tab = pathname === '/languages' ? 'templates' : pathname?.split('/').pop();
    if (tab) {
      setTab(tab);
      // Focus to correct tab
      let ref = refs[tab];
      ref.current.focus();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const handleSelectedTab = (eventKey : any) => {
    setTab(eventKey);
  }

  const handleResponsiveTabs = (eventKey : any) => {
    setIsActive(current => !current);
  }

  return (
    <div>
      <h1><FormattedMessage id={'languages.title'}/></h1>
      <p className="info">
          <i className="fa fa-info-circle me-2"></i>
          <FormattedMessage id="languages.info"/>
      </p>

      <div className="responsive-tabs-wrp">
        <div className="responsive-nav tab-buttons">
          <Button className="tab-button toggle-btn" onClick={handleResponsiveTabs}>
            <span className="active"><FormattedMessage id={"languages." + tab}/></span>
          </Button>
        </div>

        <Tab.Container activeKey={tab} defaultActiveKey={tab} id="tab" onSelect={handleSelectedTab}>
          <Nav className={'nav-tabs responsive-tabs' + (isActive ? ' show' : '')}>
              <Nav.Item>
                  <Nav.Link ref={refs.templates} eventKey="templates" as={Link} to="/languages/templates">
                    <i aria-hidden="true" className="fa fa-comments mr-2"></i>
                    <span> <FormattedMessage id="languages.templates"/></span>
                  </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                  <Nav.Link ref={refs.infos} eventKey="infos" as={Link} to="/languages/infos">
                    <i aria-hidden="true" className="fa fa-list mr-2"></i>
                    <span> <FormattedMessage id="languages.infos"/></span>
                  </Nav.Link>
              </Nav.Item>
          </Nav>
        </Tab.Container>

        <Tab.Content>
          <Outlet/>
        </Tab.Content>

      </div>
    </div>
  );
};